import _ from 'lodash'
import {connect} from 'react-redux'

import {ItineraryOverview} from './itineraryoverview.component'

const mapStateToProps = (state) => {
    let legs = state.getIn(['document', 'legs']).sortBy((leg) => { return leg.getIn(['properties', 'start']) })

    return {
        legs: legs,
        allTransportation: state.getIn(['document', 'transportation']),
        isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip']),
        lunatrip: state.getIn(['lunaTrip', 'trip']),
        fromLunaTrip: state.getIn(['lunaTrip', 'fromLunaTrip'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

const ItineraryOverviewContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItineraryOverview)

export default ItineraryOverviewContainer
